/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { LucideIcon } from "lucide-react";

import {
  MOBILE_HEADER_ICON_BADGE_CLASSES,
  MOBILE_HEADER_ICON_BUTTON_CLASSES,
} from "../../constants/mobile-header-button-styles";

type MobileIconButtonProps = {
  icon: LucideIcon;
  count?: number;
  ariaLabel: string;
  testId: string;
  onClick: () => void;
};

export const MobileIconButton = ({
  icon: Icon,
  count = 0,
  ariaLabel,
  testId,
  onClick,
}: MobileIconButtonProps) => (
  <button
    type="button"
    onClick={onClick}
    data-testid={testId}
    aria-label={ariaLabel}
    className={MOBILE_HEADER_ICON_BUTTON_CLASSES}
  >
    <Icon aria-hidden size={24} />
    {count > 0 && (
      <span
        className={`${MOBILE_HEADER_ICON_BADGE_CLASSES} ${
          count > 9 ? "min-w-5 px-[0.5rem]" : `w-4.25`
        }`}
      >
        {count}
      </span>
    )}
  </button>
);
